// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--1Vc8g","firstScreenRightCon":"firstScreenRightCon--hOzAI","scoreModule":"scoreModule--iMb96","markerAnimationScale":"markerAnimationScale--AgWUH"};